import queryString from 'query-string';
import Logger from '../../utils/logger/logger';
import UiElement from '../../../shared/ui-element/ui-element';
import EmailSubscription from '../email-subscription/email-subscription';
import Navigation from '../navigation/navigation';
import Footer from '../footer/footer';
import FontsLoader from '../../utils/fonts-loader';
import ClickTracker from '../../../shared/click-tracker/click-tracker';
import SignupModal from '../signup-modal/signup-modal';
import CookieBanner from '../cookie-banner/cookie-banner';
import RedirectTo from '../redirect-to/redirect-to';
import analytics from '../../../shared/analytics';
import healthMetrics from '../../utils/health-metrics/health-metrics';

import fontsConfig from '../../config/font-config';

import '../../main.scss';

class BasePage extends UiElement {
  signupModalOptions = {
    hideCloseBtn: false,
  };

  constructor() {
    super();

    this.signupModal = new SignupModal();
    this.analytics = analytics;
  }

  onInit() {
    Logger.initialize();
    const fontsLoader = new FontsLoader(fontsConfig);

    fontsLoader.load();
    new EmailSubscription({rootElement: '.js-base-subscription-form'}).init();
    new Navigation().init();
    new ClickTracker().init();
    new CookieBanner().init();
    new RedirectTo().init();
    new Footer().init();
    healthMetrics.initialize();

    this.signupModal.init();
    this.setSignupModalOptions();
    this.initSignUpButtons();
    this.openSignupModalFromExternalSourceIfNeeded();
    this.trackPageView();
  }

  setSignupModalOptions() {
    const query = queryString.parse(window.location.search);

    if ('hideModalCloseBtn' in query) {
      this.signupModalOptions = {...this.signupModalOptions, hideCloseBtn: true};
    }
  }

  trackPageView() {
    healthMetrics.trackIncrement({name: 'page_view'});
  }

  initSignUpButtons() {
    const buttons = document.querySelectorAll('[data-signup-button]');

    [].forEach.call(buttons, (button) => {
      button.addEventListener('click', this.handleSignUpButtonClick);
    });
  }

  handleSignUpButtonClick = (e) => {
    const {tierType, signupHideSocials} = e.currentTarget.dataset;

    this.signupModal.open({...this.signupModalOptions, tierType, signupHideSocials});
  };

  // This is a function to open Signup modal for
  // those users who came from external landings with additional get params
  openSignupModalFromExternalSourceIfNeeded() {
    const query = queryString.parse(window.location.search);
    const externalParamsInUrl = ['appId', 'bundleId', 'affiliates'];

    externalParamsInUrl.some((param) => {
      if (param in query) {
        this.signupModal.open(this.signupModalOptions);
        return true;
      }
      return false;
    });
  }
}

export default BasePage;
